import { Session } from "@equiem/web-ng-lib";
import { Site } from "@equiem/web-ng-lib";
import Head from "next/head";
import React, { useContext } from "react";

// @ts-ignore
import js from "!!raw-loader!./script.js";
import { useNonce } from "../../contexts/NonceContext";
import Script from "next/script";

export const NewRelic: React.FC = () => {
  const site = useContext(Site);
  const session = useContext(Session);
  const nonce = useNonce();

  if (process.env.newrelicEnabled !== "true") {
    return null;
  }

  const origin = site.gatewayEndpoint != null
    ? new URL(site.gatewayEndpoint).origin
    : null;

  const init = {
    distributed_tracing: {
      enabled: true,
      cors_use_newrelic_header: true,
      cors_use_tracecontext_headers: true,
      allowed_origins: [ origin ],
    },
    privacy: {
      cookies_enabled: session.authenticated,
    },
    performance: {
      capture_measures: true,
    },
    browser_consent_mode: {
      enabled: false,
    },
  };

  const loaderConfig = {
    accountID: process.env.newrelicAccountID,
    trustKey: process.env.newrelicTrustKey,
    agentID: process.env.newrelicAgentID,
    licenseKey: process.env.newrelicLicenseKey,
    applicationID: process.env.newrelicApplicationID,
  };

  const info = {
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    licenseKey: process.env.newrelicLicenseKey,
    applicationID: process.env.newrelicApplicationID,
    sa: 1,
  };

  return (
    <Head>
      <Script
        type="text/javascript"
        nonce={nonce}
        dangerouslySetInnerHTML={{ __html: `
;window.NREUM||(NREUM={});NREUM.init=${JSON.stringify(init)};
;NREUM.loader_config=${JSON.stringify(loaderConfig)}
;NREUM.info=${JSON.stringify(info)}
${js}
    `}} />
    </Head>
  );
}
